import styled from 'styled-components';

export const Wrapper = styled.header`
  position: relative;
`;
export const Spacer = styled.div`
  height: 80px;
  @media (max-width: ${({ theme }) => theme.navBreakPoints.lg}) {
    height: 64px;
  }
`;
